<span class="method-badge" *ngIf="meta" [ngStyle]="badgeStyle">
  <i [class]="meta.icon" class="method-badge-icon"></i>
  <span class="method-badge-label">{{ meta.labelKey | translate }}</span>
</span>
